
// @ts-nocheck
import { useI18n } from "vue-i18n";
import { defineComponent, ref, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import * as Cashier from "@/api/cashier";
import { Dialog, Form, Toast } from "vant";
import { baseURL } from "@/api/index";
import Realtime from "@/utils/realtime";
import { evaluateEmbedGuard, isEmbeddedByExternalOrigin, resolveParentOrigin, tryGetCachedEmbedPolicy, setCachedEmbedPolicy, shouldSkipSourceReport, markSourceReportDone } from "@/utils/embedGuard";
import { ensureCheckoutWebComponentsReady } from "@/utils/loadScript";

export default defineComponent({
  name: "payment",
  components: {},
  setup() {
    const { t, locale } = useI18n();
    const route = useRoute();
    const error = ref(false);
    const time = 1000 * 5;
    const dev = process.env.VUE_APP_BUILD_ENV;
    const NuveiForm = ref();
    // let {
    //   checkoutUrl,
    //   actionType,
    //   returnUrl,
    //   merchantNo,
    //   merOrderNo,
    //   notifyUrl,
    //   currencyCode,
    //   amount,
    //   websiteUrl,
    //   syncNotifyUrl,
    //   ipAddress,
    //   theme
    // } = route.query;

    function parsePaymentUrl(url) {
      /**
       * 解析支付URL，提取指定的查询参数。
       * @param {string} url - 完整的支付URL
       * @returns {Object} - 包含指定参数的键值对
       */

      // 期望提取的参数列表
      const expectedParams = [
        "amount",
        "websiteUrl",
        "currencyCode",
        "merOrderNo",
        "merchantNo",
        "ipAddress",
        "actionType",
        "notifyUrl",
        "syncNotifyUrl",
        "theme",
        "cReq",
        "openMode",
        "checkoutUrl" // checkoutUrl 在最后
      ];

      // 初始化结果对象
      const result = {};

      // 提取查询字符串
      const queryStart = url.indexOf("?");
      if (queryStart === -1) {
        expectedParams.forEach(param => (result[param] = null));
        return result;
      }

      const queryString = url.slice(queryStart + 1);

      // 手动解析查询参数
      const params = {};

      // 查找 checkoutUrl 的位置
      const checkoutUrlKey = "checkoutUrl=";
      const checkoutUrlStart = queryString.indexOf(checkoutUrlKey);

      if (checkoutUrlStart !== -1) {
        // 提取 checkoutUrl 的值（从 checkoutUrl= 后到末尾）
        params["checkoutUrl"] = queryString.slice(checkoutUrlStart + checkoutUrlKey.length);

        // 提取 checkoutUrl 之前的参数
        const preCheckoutQuery = queryString.slice(0, checkoutUrlStart);
        const pairs = preCheckoutQuery.split("&").filter(pair => pair);

        // 处理其他键值对
        pairs.forEach(pair => {
          const equalIndex = pair.indexOf("=");
          if (equalIndex === -1) return; // 跳过无效键值对
          const key = pair.slice(0, equalIndex);
          const value = pair.slice(equalIndex + 1);
          params[key] = value;
        });
      } else {
        // 如果没有 checkoutUrl，正常解析所有参数
        queryString
          .split("&")
          .filter(pair => pair)
          .forEach(pair => {
            const equalIndex = pair.indexOf("=");
            if (equalIndex === -1) return;
            const key = pair.slice(0, equalIndex);
            const value = pair.slice(equalIndex + 1);
            params[key] = value;
          });
      }

      // 填充结果对象
      expectedParams.forEach(param => {
        if (param in params) {
          if (param === "amount") {
            // 将 amount 转换为 number 类型
            result[param] = Number(params[param]);
          } else if (param === "checkoutUrl") {
            // checkoutUrl 保留原始字符串
            result[param] = params[param];
          } else {
            // 其他参数处理 "null" 转换为 null，并解码
            const value = decodeURIComponent(params[param] || "");
            result[param] = value === "null" ? null : value;
          }
        } else {
          result[param] = null; // 参数不存在时返回 null
        }
      });

      return result;
    }

    const parsedParams = parsePaymentUrl(window.location.href);
    const params = JSON.stringify(parsedParams, null, 2);
    console.log(JSON.parse(params));
    let {
      checkoutUrl,
      actionType,
      returnUrl,
      merchantNo,
      merOrderNo,
      notifyUrl,
      currencyCode,
      amount,
      websiteUrl,
      syncNotifyUrl,
      ipAddress,
      theme,
      cReq,
      openMode
    } = JSON.parse(params);
    if (!theme) {
      theme = "light";
    }

    const FormData = ref({
      returnUrl,
      checkoutUrl,
      websiteUrl,
      merchantNo,
      merOrderNo,
      notifyUrl,
      currencyCode,
      amount,
      syncNotifyUrl,
      ipAddress,
      cReq
    });
    const themes = {
      light: {
        colorBackground: "#ffffff",
        colorBorder: "#CED0D1",
        colorPrimary: "#09182B",
        colorSecondary: "#828687",
        colorAction: "#000000",
        colorOutline: "#FFFFFF",
        colorSuccess: "#3CB628",
        colorError: "#8B3232",
        colorDisabled: "#AAAAAA",
        colorInverse: "#ffffff",
        colorFormBackground: "#F5F5F5",
        colorFormBorder: "#F5F5F5",
        borderRadius: ["0px", "0px"],
        subheading: {
          fontFamily:
            "'Work Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif;",
          fontSize: "16px",
          lineHeight: "24px",
          fontWeight: 500,
          letterSpacing: 0
        },
        footnote: {
          fontFamily:
            "'Work Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif;",
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: 400,
          letterSpacing: 0
        },
        button: {
          fontFamily:
            "'Work Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif;",
          fontSize: "16px",
          lineHeight: "24px",
          fontWeight: 500,
          letterSpacing: 0
        },
        input: {
          fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif;",
          fontSize: "16px",
          lineHeight: "20px",
          fontWeight: 400,
          letterSpacing: 0
        },
        label: {
          fontFamily:
            "'Work Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif;",
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: 500,
          letterSpacing: 0
        }
      },
      dark: {
        colorBackground: "#0A0A0C",
        colorBorder: "#68686C",
        colorPrimary: "#F9F9FB",
        colorSecondary: "#828388",
        colorAction: "#5E48FC",
        colorOutline: "#ADA4EC",
        colorSuccess: "#2ECC71",
        colorError: "#FF3300",
        colorDisabled: "#64646E",
        colorInverse: "#F9F9FB",
        colorFormBackground: "#1F1F1F",
        colorFormBorder: "#1F1F1F",
        borderRadius: ["8px", "8px"],
        subheading: {
          fontFamily:
            "'Roboto Mono', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif;",
          fontSize: "16px",
          lineHeight: "24px",
          fontWeight: 700,
          letterSpacing: 0
        },
        footnote: {
          fontFamily:
            "'PT Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif;",
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: 400,
          letterSpacing: 0
        },
        button: {
          fontFamily:
            "'Roboto Mono', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif;",
          fontSize: "16px",
          lineHeight: "24px",
          fontWeight: 700,
          letterSpacing: 0
        },
        input: {
          fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif;",
          fontSize: "16px",
          lineHeight: "20px",
          fontWeight: 400,
          letterSpacing: 0
        },
        label: {
          fontFamily:
            "'Roboto Mono', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif;",
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: 400,
          letterSpacing: 0
        }
      }
    };
    const kycInfo = ref(null);

    const LinkedPayForm = ref();
    const initCheckoutWebComponents = ref(false);
    /**
     * 初始化 Checkout.com 组件（按需加载 SDK）。
     *
     * 业务流程：
     * 1. 动态加载 Checkout Web Components
     * 2. 创建并挂载 flow 组件
     */
    const CheckoutWebComponentsInit = async (paymentSessionObject, paymentSessionPublicKey) => {
      if (initCheckoutWebComponents.value) return;
      const CheckoutWebComponents = await ensureCheckoutWebComponentsReady();
      const checkout = await CheckoutWebComponents({
        paymentSession: JSON.parse(paymentSessionObject),
        publicKey: paymentSessionPublicKey,
        environment: ["prod", "sunpayprod"].includes(process.env.VUE_APP_BUILD_ENV)
          ? "production"
          : "sandbox",
        appearance: themes[(theme as string) || "light"],
        componentOptions: {
          googlepay: {
            buttonType: "plain",
            buttonColor: "white"
          }
        }
      });
      const flowComponent = checkout.create("flow");
      nextTick(() => {
        flowComponent.mount("#flow-container");
        initCheckoutWebComponents.value = true;
      });
    };

    const getOrderInfo = async () => {
      const res = await Cashier.CallBackUrlTopUpOrder();
      if (res?.code === 200) {
        kycInfo.value = res?.data?.kycInfo ? JSON.parse(res?.data?.kycInfo || {}) : {};

        // 关闭
        if ([6].includes(res?.data?.orderStatus)) {
          // error.value = true;
          return;
        }

        // // 失败、取消
        // if ([3, 4].includes(res?.data?.orderStatus)) {
        //   if (res?.data?.cancelUrl) {
        //     window.location.href = res?.data?.cancelUrl;
        //   }
        //   return;
        // }

        // // 成功
        // if (res?.data?.orderStatus == 2) {
        //   if (res?.data?.redirectUrl) {
        //     window.location.href = res?.data?.redirectUrl;
        //   }
        //   return;
        // }

        // 成功, 失败、取消
        if ([2, 3, 4].includes(res?.data?.orderStatus)) {
          if (res?.data?.redirectUrl) {
            window.location.href = res?.data?.redirectUrl;
          }
          return;
        }
      }

      setTimeout(() => {
        getOrderInfo();
      }, time);
    };

    /**
     * 尽快提交 3DS / 上游 REDIRECT（参数已在 URL 时不依赖订单接口）。
     *
     * 业务流程：
     * 1. openMode=top → 顶层打开 checkoutUrl（Payabl 卡 3DS / AP / GP，禁止 iframe）
     * 2. 有 cReq → Nuvei creq 表单提交到 iframe
     * 3. 否则有 checkoutUrl → iframe 直接打开上游页
     */
    const startRedirectCheckout = () => {
      if (actionType != "REDIRECT") {
        return false;
      }
      const decodedCheckoutUrl =
        checkoutUrl && typeof checkoutUrl == "string" ? decodeURIComponent(checkoutUrl) : "";
      if (String(openMode || "").toLowerCase() === "top" && decodedCheckoutUrl) {
        const target = window.top || window;
        target.location.href = decodedCheckoutUrl;
        return true;
      }
      if (cReq) {
        setTimeout(() => {
          NuveiForm.value?.submit();
        }, 50);
        return true;
      }
      if (decodedCheckoutUrl) {
        document.getElementById("myIframe")?.setAttribute("src", decodedCheckoutUrl);
        return true;
      }
      return false;
    };

    /**
     * 绑定 iframe load：用于跳回 syncNotifyUrl / returnUrl。
     */
    const bindIframeReturnListener = () => {
      let timeStamp = 0;
      const myIframe: HTMLElement =
        document.getElementById("myIframe") || document.createElement("iframe");
      myIframe.addEventListener("load", function(e) {
        if (timeStamp == 0) {
          timeStamp = e.timeStamp;
          return;
        }
        if (e.timeStamp > timeStamp && timeStamp !== 0) {
          if (returnUrl && typeof returnUrl == "string") {
            window.location.href = returnUrl;
          }
        }
      });
    };

    onMounted(async () => {
      /**
       * /payment（3DS 中间页）嵌入守卫与风险上报。
       *
       * 业务流程：
       * 1. 判定是否「外域父页嵌入」（同源收银台自嵌 3DS 不算）
       * 2. 外域嵌入：仍 await Report + Policy，硬拦后再决定是否关页
       * 3. 顶层 / 同源：REDIRECT 参数齐全时先提交 3DS，Report/Policy/订单接口后台进行
       * 4. FORM / COMPONENT / APGP 仍依赖 CallBackUrlTopUpOrder
       */
      let embedBlockedLocal = false;
      const isEmbedded = window.self !== window.top;
      const referrer = document.referrer || '';
      const externallyEmbedded = isEmbeddedByExternalOrigin(referrer);
      const parentOrigin = externallyEmbedded ? (resolveParentOrigin(referrer) || '') : '';
      const reportPayload = {
        referrer,
        is_embedded: externallyEmbedded,
        page_url: window.location.href,
        user_agent: navigator.userAgent || '',
        parent_origin: parentOrigin,
      };

      const runReport = async () => {
        try {
          if (shouldSkipSourceReport(reportPayload)) {
            console.info('[CardPaySourceGuard] payment ReportPaySourceContext skipped (debounce)');
            return;
          }
          const reportRes = await Cashier.ReportPaySourceContext(reportPayload);
          if (externallyEmbedded && reportRes && reportRes.code != null && reportRes.code != 200) {
            embedBlockedLocal = true;
            error.value = true;
            console.warn('[CardPaySourceGuard] payment ReportPaySourceContext rejected', reportRes);
          } else if (reportRes && reportRes.code == 200) {
            markSourceReportDone(reportPayload);
          }
        } catch (e) {
          console.warn('[CardPaySourceGuard] payment ReportPaySourceContext failed', e);
          if (externallyEmbedded) {
            embedBlockedLocal = true;
            error.value = true;
          }
        }
      };

      const runPolicy = async () => {
        try {
          const cachedPolicy = tryGetCachedEmbedPolicy();
          if (cachedPolicy) {
            const decision = evaluateEmbedGuard(cachedPolicy, {
              denyExternalEmbed: true,
              referrer,
            });
            if (decision.block) {
              embedBlockedLocal = true;
              error.value = true;
              console.warn('[CardPaySourceGuard] payment embed blocked (cached)', decision.reason, cachedPolicy);
            }
            return;
          }
          const policyRes = await Cashier.GetCashierEmbedPolicy();
          if (policyRes?.code == 200) {
            setCachedEmbedPolicy(policyRes.data);
            const decision = evaluateEmbedGuard(policyRes.data, {
              denyExternalEmbed: true,
              referrer,
            });
            if (decision.block) {
              embedBlockedLocal = true;
              error.value = true;
              console.warn('[CardPaySourceGuard] payment embed blocked', decision.reason, policyRes.data);
            }
          } else if (externallyEmbedded) {
            embedBlockedLocal = true;
            error.value = true;
            console.warn('[CardPaySourceGuard] payment embed policy non-200 while externally embedded', policyRes);
          }
        } catch (e) {
          if (externallyEmbedded) {
            embedBlockedLocal = true;
            error.value = true;
            console.warn('[CardPaySourceGuard] GetCashierEmbedPolicy failed while externally embedded', e);
          } else {
            console.warn('[CardPaySourceGuard] GetCashierEmbedPolicy failed', e);
          }
        }
      };

      // REDIRECT 且 URL 已带 3DS 参数：顶层/同源可先提交，再后台做风控
      const canFastRedirect =
        !externallyEmbedded &&
        actionType == "REDIRECT" &&
        !!(cReq || checkoutUrl);

      if (canFastRedirect) {
        startRedirectCheckout();
        bindIframeReturnListener();
        runReport();
        runPolicy();
        // 后台查单：关单/失败跳转、APGP 兜底
        Cashier.CallBackUrlTopUpOrder()
          .then((res) => {
            if (res?.code !== 200) {
              return;
            }
            if ([6].includes(res?.data?.orderStatus)) {
              return;
            }
            if ([3, 4].includes(res?.data?.orderStatus)) {
              if (res?.data?.cancelUrl) {
                window.location.href = res.data.cancelUrl;
              }
              return;
            }
            if (["APPLEPAY", "GOOGLEPAY"].includes(res?.data?.accountType) && res?.data?.commPageUrl) {
              window.location.href = res.data.commPageUrl;
            }
          })
          .catch((e) => console.warn('[payment] CallBackUrlTopUpOrder failed', e));
        setTimeout(() => {
          getOrderInfo();
        }, time);
        return;
      }

      if (externallyEmbedded) {
        await runReport();
        await runPolicy();
        if (embedBlockedLocal) {
          return;
        }
      } else {
        runReport();
        await runPolicy();
        if (embedBlockedLocal) {
          return;
        }
      }

      const res = await Cashier.CallBackUrlTopUpOrder();
      if (res?.code === 200) {
        kycInfo.value = res?.data?.kycInfo ? JSON.parse(res?.data?.kycInfo || {}) : {};

        if ([6].includes(res?.data?.orderStatus)) {
          return;
        }

        if ([3, 4].includes(res?.data?.orderStatus)) {
          window.location.href = res?.data?.cancelUrl;
          return;
        }

        if (["APPLEPAY", "GOOGLEPAY"].includes(res?.data?.accountType)) {
          if (res?.data?.commPageUrl) {
            window.location.href = res?.data?.commPageUrl;
            return;
          }
        }

        if (actionType == "FORM") {
          if (checkoutUrl && merchantNo && merOrderNo && currencyCode && amount) {
            const loadingToast = Toast({
              message: "",
              type: "loading",
              overlay: true,
              duration: 0
            });
            const result = await Cashier.GetFiatOrderLinkUsed();
            loadingToast.close();
            if (result?.code === 200) {
              if (!result?.data) {
                LinkedPayForm.value.submit();
                setTimeout(() => {
                  document.getElementById("MyForm")?.setAttribute("target", "_top");
                }, 200);
              } else {
                Dialog({
                  title: t("tips"),
                  message: t("used"),
                  confirmButtonText: t("yes")
                });
              }
            }
          }
        } else if (actionType == "REDIRECT") {
          startRedirectCheckout();
        } else if (actionType == "COMPONENT") {
          CheckoutWebComponentsInit(
            res?.data?.paymentSessionObject,
            res?.data?.paymentSessionPublicKey
          );
        }

        bindIframeReturnListener();
        setTimeout(() => {
          getOrderInfo();
        }, time);
      }
    });

    const ListenerOrderStatusBySocket = id => {
      const RealtimePush = Realtime.initRealtimePush(`${baseURL}ws/orders/${id}`, { id });
      if (RealtimePush) {
        RealtimePush.onmessage = event => {
          console.log("收到消息: " + event);
          if (event?.data === "CANCEL") {
            // error.value = true;
          }
        };
      }
    };

    return {
      dev,
      error,
      theme,
      kycInfo,
      FormData,
      LinkedPayForm,
      NuveiForm,
      actionType
    };
  }
});
